import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import { ClpPopulation, HighCommissionBoosting, SaleBurying } from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      {
        newName: HighCommissionBoosting.NAME,
        oldNameMatcher: /^plp_hc_boosting/m,
      },
      {
        newName: SaleBurying.NAME,
        oldNameMatcher: /^plp_sale_burying/m,
      },
      {
        newName: ClpPopulation.NAME,
        oldNameMatcher: /^clp_population/m,
      },
    ],
  });
};
